import { Link } from 'react-router-dom'

import { NavItem } from './NavItem'
import { Button } from '@/components/ui/button'
import { MobileNavbar } from './MobileNavbar'
import { MobileNavItem } from './MobileNavItem'
import { Flag } from '@/components/Flag'
import { config } from '../../../config'
import { useTranslation } from '@/hooks/useTranslation'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
} from '@/components/ui/select'

export function Header() {
	const { t, i18n } = useTranslation()
	const currentLang = i18n.language?.split('-')[0] || 'en'
	const isFrench = currentLang === 'fr'
	const homePath = isFrench ? '/fr' : '/'
	const productLabel = isFrench ? 'Produit' : 'Product'
	const howItWorks = isFrench ? 'Comment ça marche' : 'How it works'
	const docsLabel = 'Docs'
	const startFree = isFrench ? 'Commencer gratuitement' : 'Start for free'

	return (
		<header className="relative z-50">
				<div className="container mx-auto py-2">
				<div className="flex items-center justify-between gap-6">
					<Link to={`${homePath}#product`} className="flex shrink-0 items-center" aria-label="Feedbask home">
						<img src={config.logo} alt="Feedbask" className="h-8 sm:h-9" />
					</Link>

					<nav className="hidden items-center gap-8 lg:flex">
						<NavItem href={`${homePath}#product`} label={productLabel} />
						<NavItem href={`${homePath}#how-it-works`} label={howItWorks} />
						<NavItem href={`${homePath}#pricing`} label={t('pricing.label')} />
						<NavItem href="/docs" label={docsLabel} />
					</nav>

					<div className="hidden items-center gap-3 lg:flex">
						<Select value={currentLang} onValueChange={(value) => i18n.changeLanguage(value)}>
							<SelectTrigger
								className="h-9 w-[104px] border-slate-200 bg-white [&>span]:!flex"
								aria-label={isFrench ? 'Langue' : 'Language'}
							>
								<span className="flex items-center gap-2">
									<Flag code={currentLang} />
									<span>{currentLang.toUpperCase()}</span>
								</span>
							</SelectTrigger>
							<SelectContent className="z-[80]" style={{ zIndex: 80 }}>
								<SelectItem value="en">
									<span className="flex items-center gap-2">
										<Flag code="en" />
										EN
									</span>
								</SelectItem>
								<SelectItem value="fr">
									<span className="flex items-center gap-2">
										<Flag code="fr" />
										FR
									</span>
								</SelectItem>
							</SelectContent>
						</Select>
						<Link to="/auth" className="px-2 text-sm font-semibold text-slate-600 transition-colors hover:text-slate-950">
							{t('header.logIn')}
						</Link>
						<Button
							asChild
							size="sm"
							className="h-9 rounded-full bg-[#6547D9] px-4 font-semibold text-white hover:bg-[#5638C7]"
						>
							<Link to="/auth">{startFree}</Link>
						</Button>
					</div>

					<MobileNavbar>
						<div className="container mt-4 rounded-2xl border border-slate-200 bg-white py-4 text-foreground shadow-sm">
							<nav className="flex flex-col gap-1">
								<MobileNavItem href={`${homePath}#product`} label={productLabel} />
								<MobileNavItem href={`${homePath}#how-it-works`} label={howItWorks} />
								<MobileNavItem href={`${homePath}#pricing`} label={t('pricing.label')} />
								<MobileNavItem href="/docs" label={docsLabel} />
								<div className="mt-2 px-3">
									<Select value={currentLang} onValueChange={(value) => i18n.changeLanguage(value)}>
										<SelectTrigger className="h-10 w-full border-slate-200 bg-white [&>span]:!flex" aria-label={isFrench ? 'Langue' : 'Language'}>
											<span className="flex items-center gap-2">
												<Flag code={currentLang} />
												<span>{currentLang.toUpperCase()}</span>
											</span>
										</SelectTrigger>
										<SelectContent className="z-[80]" style={{ zIndex: 80 }}>
											<SelectItem value="en">
												<span className="flex items-center gap-2">
													<Flag code="en" />
													EN
												</span>
											</SelectItem>
											<SelectItem value="fr">
												<span className="flex items-center gap-2">
													<Flag code="fr" />
													FR
												</span>
											</SelectItem>
										</SelectContent>
									</Select>
								</div>
								<Link to="/auth" className="mt-2 px-3 py-2 text-center text-sm font-semibold text-slate-600">
									{t('header.logIn')}
								</Link>
								<Button
									size="lg"
									asChild
									className="mt-1 w-full rounded-full bg-[#6547D9] font-semibold text-white hover:bg-[#5638C7]"
								>
									<Link to="/auth">{startFree}</Link>
								</Button>
							</nav>
						</div>
					</MobileNavbar>
				</div>
			</div>
		</header>
	)
}
